/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Indicators} from '../../components/indicators/Indicator';
import {DLSTheme} from '../../types/types';
import Indicator from '../indicators/Indicator';

export interface FormLabelProps {
  label: string;
  indicator?: Indicators;
}

const useStyles = makeStyles((theme: DLSTheme) => ({
  label : {
    ...theme.dls.typography.body3,
    fontSize   : '16px',
    fontWeight : 500
  }
}));

/**
 * FormLabel is a component that displays a customizable form label with consistent styling and the 
 * option to display an indicator (NEW, BETA, LEGACY, etc).
 * 
 * ```typescript
 * 
 *   import FormLabel from '@ion/dls/src/components/forms/FormLabel';
 * 
 *   <FormLabel indicator={Indicators.NEW}
 *     label={label} />
 * 
 * ```
 */
export const FormLabel = ({
  indicator,
  label
}: FormLabelProps) => {
  const classes = useStyles();
  return (
    <span>
      {indicator ? (<Indicator variant={indicator}/>) : undefined}
      <span className={classes.label}>
        {label}
      </span>
    </span>
  );
};

export default FormLabel;
